import React, {useRef} from 'react';
import { Carousel, Card, Typography, Tooltip, Tag, Divider, Row, Col } from 'antd';
import { FundViewOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import {DoubleLine} from "../../Components/Labels";
import GraphicCard from "../../Components/GraphicCard";
import {iconMapping} from "../../Configs/AppsConfig";

const { Title, Text } = Typography;

const PredefinedGroups = ({ onSelectGroup }) => {
  let carouselRef = useRef(null);
  const groups = [
    {
      id: 1,
      name: "Top Equity ETFs",
      etfs: ['QQQ', 'SPY', 'VTV'],
      description: "This group represents the leading ETFs in the equity market, providing diverse exposure.",
      imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/NEWEST-7-9-2024/color-splash-vibrant-waves.jpeg'
    },
    {
      id: 2,
      name: 'Tech ETFs',
      etfs: ['VGT', 'XLK', 'QQQ'],
      description: "Focused on technology, these ETFs include major companies that are market leaders in tech.",
      imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/NEWEST-7-9-2024/tech-theme-bubble.jpeg'
    },
    {
      id: 3,
      name: 'Healthcare ETFs',
      etfs: ['VHT', 'XLV', 'IHF'],
      description: "Healthcare ETFs offer investment opportunities in biotech, pharmaceuticals, and medical devices.",
      imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/NEWEST-7-9-2024/medical-new.jpeg'
    },
    // Add more groups as needed
  ];

  const next = () => {
    carouselRef.current.next();
  };

  const prev = () => {
    carouselRef.current.prev();
  };

  return (
      <Row>
        {groups.map(group => (
          <div key={group.id} onClick={() => onSelectGroup(group.etfs)} style={{ margin: '16px' }}>
            <GraphicCard
              imgUrl={group.imgUrl}
              title={group.name}
              description={group.description}
              iconUrl={'https://storage.googleapis.com/finiat-web-static-resources/backgrounds/play-button-gray.jpg'} // Replace with the icon related to the group, if you have one
            />
          </div>
        ))}
      </Row>
  );
};

export default PredefinedGroups;
